import React from 'react';
import { Card, Pill, Logo, EntityLink } from './ui';
import StandingsTable from './StandingsTable';
import { seasonStatus, leagueTier } from '../../lib/leagueHelpers';
import { fmtMDY } from '../../lib/clubHelpers';

export default function LeagueOverview({ data }) {
  const d = data?.detail || {};
  const season = d?.currentseason || data?.currentSeason;
  const st = seasonStatus(season);
  const teams = data?.teams || [];
  const seasons = d?.seasons || [];

  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <Card title="League info">
        <div className="i-row"><span className="i-mute">Country</span><span className="i-fg">{d?.country?.name || '—'}</span></div>
        <div className="i-row"><span className="i-mute">Type</span><span className="i-fg">{[d?.type, d?.sub_type].filter(Boolean).join(' · ') || '—'}</span></div>
        <div className="i-row"><span className="i-mute">Tier</span><span className="i-fg">{leagueTier(d)}</span></div>
        <div className="i-row"><span className="i-mute">Short code</span><span className="i-fg">{d?.short_code || '—'}</span></div>
        <div className="i-row"><span className="i-mute">Category</span><span className="i-fg">{d?.category || '—'}</span></div>
        <div className="i-row"><span className="i-mute">Last played</span><span className="i-fg">{fmtMDY(d?.last_played_at)}</span></div>
        <div className="i-row"><span className="i-mute">Current season</span><span className="i-fg">{season?.name || '—'}{st.status === 'live' && <Pill className="i-pos-def ml-2">Live</Pill>}</span></div>
        <div className="i-row"><span className="i-mute">Start</span><span className="i-fg">{fmtMDY(season?.starting_at)}</span></div>
        <div className="i-row"><span className="i-mute">End</span><span className="i-fg">{fmtMDY(season?.ending_at)}</span></div>
        <div className="i-row"><span className="i-mute">Status</span><span className="i-fg"><Pill className={st.status === 'live' ? 'i-pos-def' : st.status === 'finished' ? 'i-bd' : ''}>{st.label}</Pill></span></div>
      </Card>

      <Card title={`Teams in season (${teams.length})`}>
        <div className="grid grid-cols-2 gap-2">
          {(Array.isArray(teams) ? teams : []).map((t, i) => (
            <EntityLink key={i} to={t?.id ? `/club/${t.id}` : null} className="flex items-center gap-2 i-mute hover:i-fg text-sm">
              <Logo src={t?.image_path} alt={t?.name} size={20} fallback={t?.name} />
              <span className="truncate">{t?.name || '—'}</span>
              {t?.short_code && <span className="i-dim text-xs">{t.short_code}</span>}
            </EntityLink>
          ))}
        </div>
        {!teams.length && <p className="i-dim text-xs">No teams.</p>}
      </Card>

      <Card title="Regular-season standings">
        <StandingsTable rows={data?.standings || []} highlightParticipantId={null} />
      </Card>

      <Card title={`Historical seasons (${seasons.length})`}>
        {(Array.isArray(seasons) ? seasons.slice(0, 20) : []).map((s, i) => {
          const ss = seasonStatus(s);
          return (
            <div key={i} className="i-row">
              <span className="i-mute">{s?.name || '—'}{s?.starting_at ? ` · ${fmtMDY(s.starting_at)}` : ''}</span>
              <Pill className={ss.status === 'live' ? 'i-pos-def' : ss.status === 'finished' ? 'i-bd' : ''}>{ss.label}</Pill>
            </div>
          );
        })}
        {!seasons.length && <p className="i-dim text-xs">No historical seasons.</p>}
      </Card>
    </div>
  );
}
